import { render, staticRenderFns } from "./TileGridWidgetImageTile.vue?vue&type=template&id=39e473ed&scoped=true"
import script from "./TileGridWidgetImageTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileGridWidgetImageTile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TileGridWidgetImageTile.vue?vue&type=style&index=0&id=39e473ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e473ed",
  null
  
)

export default component.exports